import type {
  IntegrationCrmSettings,
  IntegrationItem,
  IntegrationStatus,
  TelegramSettings,
} from '@/api/integrations/integrations.types'
import { getIntegrationPublicUrl } from '@/helpers/notificationIntegration'
import {
  canConnectVkCrmIntegration,
  createDefaultVkCrmSettings,
  getIntegrationsListErrorText,
  isMaskedSecret,
  MASKED_SECRET_PLACEHOLDER,
  getCredentialInputValue,
  mergeVkCrmSettingsForSave,
  normalizeIntegrationTrafficChannelId,
  VK_CRM_STATUS_LABELS,
  VK_CRM_USAGE,
} from '../../VkCrmCommunitiesSettings/lib/vkCrmIntegration.helpers'

export const TG_CRM_USAGE = VK_CRM_USAGE

export const TG_CRM_STATUS_LABELS = VK_CRM_STATUS_LABELS

export const canConnectTgCrmIntegration = canConnectVkCrmIntegration
export const createDefaultTgCrmSettings = createDefaultVkCrmSettings
export const mergeTgCrmSettingsForSave = mergeVkCrmSettingsForSave
export {
  getIntegrationsListErrorText,
  isMaskedSecret,
  MASKED_SECRET_PLACEHOLDER,
  getCredentialInputValue,
}

export const isTgCrmIntegration = (item: IntegrationItem): boolean => {
  const usages = item.usages
  if (!Array.isArray(usages) || usages.length === 0) return true
  if (usages.includes(TG_CRM_USAGE)) return true
  const notificationOnly = usages.every(
    (usage) =>
      usage === 'notifications' ||
      usage === 'password_reset' ||
      usage === 'mailing' ||
      usage === 'support',
  )
  return !notificationOnly
}

export const filterTgCrmIntegrations = (
  items: IntegrationItem[] | null | undefined,
): IntegrationItem[] => {
  if (!Array.isArray(items)) return []
  return items.filter(isTgCrmIntegration)
}

export const getTgBotUsername = (
  item: IntegrationItem | null | undefined,
): string => {
  if (!item) return ''
  const username = (item.settings as TelegramSettings | undefined)?.bot_username
  if (!username) return ''
  return String(username).replace(/^@/, '').trim()
}

export const getTgBotUrl = (
  item: IntegrationItem | null | undefined,
): string | null => {
  if (!item) return null
  return getIntegrationPublicUrl(item)
}

export const readTgCrmSettings = (
  item: IntegrationItem | null | undefined,
): IntegrationCrmSettings => {
  const crm = (item?.settings as TelegramSettings | undefined)?.crm
  return createDefaultVkCrmSettings({
    funnel_id: crm?.funnel_id ?? null,
    traffic_channel_id: normalizeIntegrationTrafficChannelId(
      crm?.traffic_channel_id,
    ),
    create_lead: crm?.create_lead ?? true,
    create_chat: crm?.create_chat ?? true,
    lead_fields:
      crm?.lead_fields && Array.isArray(crm.lead_fields) ? crm.lead_fields : [],
    access: {
      roles: crm?.access?.roles ?? [],
      departments: crm?.access?.departments ?? [],
    },
  })
}

export type { IntegrationStatus }
